import { getArrowInfo } from 'tldraw';
import { getAlignedArrowPageCurve } from './alignedArrowCurve';

function unitVec(from, to) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const len = Math.hypot(dx, dy) || 1;
  return { x: dx / len, y: dy / len };
}

/**
 * Page-space endpoints from stock tldraw arrow info (or props fallback).
 */
export function getArrowTerminalPagePoints(editor, arrowShape) {
  const shape =
    typeof arrowShape === 'string' ? editor.getShape(arrowShape) : arrowShape;
  if (!shape || shape.type !== 'arrow') return null;

  const transform = editor.getShapePageTransform(shape.id);
  if (!transform) return null;

  const aligned = getAlignedArrowPageCurve(editor, shape);
  if (aligned?.start && aligned?.end) {
    return {
      startPage: aligned.start,
      endPage: aligned.end,
      midPage: aligned.mid,
      startToward: aligned.cp1,
      endToward: aligned.cp2,
      startOut: unitVec(aligned.cp1, aligned.start),
      endOut: unitVec(aligned.cp2, aligned.end),
    };
  }

  const info = getArrowInfo(editor, shape);
  let startLocal;
  let endLocal;

  if (info?.start?.point && info?.end?.point) {
    startLocal = info.start.point;
    endLocal = info.end.point;
  } else if (shape.props?.start && shape.props?.end) {
    startLocal = shape.props.start;
    endLocal = shape.props.end;
  } else {
    return null;
  }

  const startPage = transform.applyToPoint(startLocal);
  const endPage = transform.applyToPoint(endLocal);
  return {
    startPage,
    endPage,
    midPage: {
      x: (startPage.x + endPage.x) / 2,
      y: (startPage.y + endPage.y) / 2,
    },
    startToward: endPage,
    endToward: startPage,
    startOut: unitVec(endPage, startPage),
    endOut: unitVec(startPage, endPage),
  };
}
